/* eslint-disable */
/* tslint:disable */

import React, { useEffect, useState } from 'react';
import axios from 'axios';
import PrintButton from './PrintButton';

export default function ListPdfDownloadButton({
	titulo = '',
	subtitulo = '',
	cabeceras = [],
	datos = [],
}) {
	const [prevDatos, setPrevDatos] = useState([]);
	const [url, setUrl] = useState('');

	const downloadListPdf = (data) => {
		axios
			.post(
				`${axios.defaults.baseURL}/api/generate-pdf`,
				{
					title: titulo,
					subtitle: subtitulo,
					headers: cabeceras,
					data,
				},
				{
					responseType: 'blob',
					withCredentials: true,
				}
			)
			.then((response) => {
				const url = window.URL.createObjectURL(
					new Blob([response.data], { type: 'application/pdf' })
				);
				setUrl(url);
			})
			.catch((error) => {
				console.error('Error generando pdf', error);
				return null;
			});
	};

	// eslint-disable-next-line
	useEffect(() => {
		if (datos.length !== prevDatos.length) {
			downloadListPdf(datos);
		}
		setPrevDatos(datos);
	}, [datos]);

	return (
		<PrintButton
			url={url}
			disabled={url === ''}
			variant={'outlined'}
			color={'inherit'}
		/>
	);
}
